import { Steps } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNewInventoryMovementAction,
  clearOperationResultAction,
  initializeInventoryMovementUI,
  setReceiveInventoryCurrentStepAction,
} from "../../../store/inventory/inventoryActions";
import PermissionWrapper from "../../navigation/PermissionWrapper";
import { PreservableStatePageWrapper } from "../../shared/PreservableStatePageWrapper";
import openNotificationOperationResult from "../../shared/openNotificationOperationResult";
import MoveInventorySummary from "../shared/MoveInventorySummary";
import ReceiveInventoryStep1 from "./ReceiveInventoryStep1";
import ReceiveInventoryStep2 from "./ReceiveInventoryStep2";

//
const stepsContent = {
  padding: 8,
};

const ReceiveInventorySteps = () => {
  //
  const dispatch = useDispatch();

  //
  const currentStep = useSelector(
    (state) => state.inventory.moveInventory.ui.receiveInventoryCurrentStep
  );
  const operationResult = useSelector(
    (state) => state.inventory.operationResult
  );

  //
  useEffect(() => {
    if (
      operationResult &&
      operationResult.Name === "ProcessMovement" &&
      operationResult.Outcome === "Success"
    ) {
      dispatch(setReceiveInventoryCurrentStepAction(2));
    }

    openNotificationOperationResult(
      operationResult,
      () => dispatch(clearOperationResultAction()),
      false
    );
  }, [operationResult]);

  return (
    <PermissionWrapper entityName="MoveInventory">
      <PreservableStatePageWrapper
        onCleanup={() => {
          dispatch(clearNewInventoryMovementAction());
          dispatch(initializeInventoryMovementUI());
        }}
      >
        <Steps
          current={currentStep}
          size="small"
          items={[
            { title: "Select Shipment Type" },
            { title: "Define Details" },
            { title: "Confirmation" },
          ]}
        />

        <div style={stepsContent}>
          {currentStep === 0 && <ReceiveInventoryStep1 />}
          {currentStep === 1 && <ReceiveInventoryStep2 />}
          {currentStep === 2 && (
            <MoveInventorySummary
              returnButtonTitle="Receive More Inventory"
              resetAction={() => {
                dispatch(setReceiveInventoryCurrentStepAction(0));
              }}
            />
          )}
        </div>
      </PreservableStatePageWrapper>
    </PermissionWrapper>
  );
};

export default ReceiveInventorySteps;
